import {
  Button,
  Flex,
  FormControl,
  Text,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { BookingLocation } from "../../data/occupancy.api";
import BookingSchedule from "./BookingSchedule";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  startDate: string;
  endDate: string;
  location: BookingLocation;
};

const FullBookingScheduleModal = ({
  isOpen,
  onClose,
  location,
  startDate,
  endDate,
}: Props) => {
  const [selectedDate, setSelectedDate] = useState(startDate);

  const [page, setPage] = useState(0);
  const pageSize = 5;

  const currentPage = useMemo(() => {
    return location.bookedEntitys
      .slice()
      .sort((a, b) => a.description.localeCompare(b.description, undefined, { numeric: true, sensitivity: 'base' }))
      .slice(page * pageSize, page * pageSize + pageSize);
  }, [location, page]);

  const totalPages = useMemo(() => {
    return Math.ceil(location.bookedEntitys.length / pageSize);
  }, [location, pageSize]);

  useEffect(() => {
    setSelectedDate(startDate);
  }, [startDate]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>Full Booking Schedule</ModalHeader>
        <ModalBody>
          <FormControl mb={4}>
            <FormLabel>Selected Date</FormLabel>
            <Input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </FormControl>

          {currentPage.map((desk) => (
            <FormControl mb={1}>
              <FormLabel fontSize="sm" mb={0}>
                {desk.description}
              </FormLabel>
              <BookingSchedule
                deskId={desk.id}
                startDate={selectedDate}
                endDate={moment(selectedDate)
                  .add(moment(endDate).diff(startDate, "day"), "day")
                  .format("YYYY-MM-DD")}
                location={location}
              />
            </FormControl>
          ))}

          <Flex justify="space-between" mt={4}>
            <Button
              variant="outline"
              colorScheme="lancsBlue"
              isDisabled={page <= 0}
              onClick={() => setPage((p) => p - 1)}
              size="sm"
            >
              Prev
            </Button>
            <Text opacity={0.7}>
              {page + 1}/{totalPages}
            </Text>
            <Button
              variant="outline"
              colorScheme="lancsBlue"
              isDisabled={page >= totalPages - 1}
              onClick={() => setPage((p) => p + 1)}
              size="sm"
            >
              Next
            </Button>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FullBookingScheduleModal;
